// Generated by purs version 0.15.10
var WsMessage = /* #__PURE__ */ (function () {
    function WsMessage(value0) {
        this.value0 = value0;
    };
    WsMessage.create = function (value0) {
        return new WsMessage(value0);
    };
    return WsMessage;
})();
var WsError = /* #__PURE__ */ (function () {
    function WsError() {

    };
    WsError.value = new WsError();
    return WsError;
})();
var WsClose = /* #__PURE__ */ (function () {
    function WsClose(value0) {
        this.value0 = value0;
    };
    WsClose.create = function (value0) {
        return new WsClose(value0);
    };
    return WsClose;
})();
var hoistWsCommand = function (nat) {
    return function (cmd) {
        return {
            sendMessage: function ($2) {
                return nat(cmd.sendMessage($2));
            },
            close: nat(cmd.close)
        };
    };
};
var createWs = function (dict) {
    return dict.createWs;
};
export {
    createWs,
    WsMessage,
    WsError,
    WsClose,
    hoistWsCommand
};
